export default __webpack_public_path__ + "static/media/online.03b75370.svg";